import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';

/**
 * @summary MultivalueColumn
 * @extends {i18nMixin(AoflElement)}
 */
@customElement('multivalue-column')
class MultivalueColumn extends i18nMixin(AoflElement) {
  @property({type: Array, attribute: true})
  values = [];

  @property({type: Number, attribute: true})
  visibleItems = 1;

  /**
   * Creates an instance of MultivalueColumn.
   */
  constructor() {
    super();
  }

  /**
   * @readonly
   */

  static is = 'multivalue-column';

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }
}

export default MultivalueColumn;
